import FAQSectionI18n from "@/components/landing/shared/FAQSectionI18n";

const FAQKnowledgeBaseSection = () => {
  return <FAQSectionI18n translationPrefix="knowledgeBasePage" itemClass="bg-secondary/50 rounded-xl border border-border px-6" />;
};

export default FAQKnowledgeBaseSection;
